import React from "react";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getUnreadCount,
  unreadCountToZero,
  emptyBackupChat,
  toggleDrawer,
} from "../../../../Actions/messagesAction";
import RouteHeader from "../../RouteHeader/routeHeader";
import Card from "../../../../Helper/CardWrapper/cardWrapper";
import { withStyles } from "@material-ui/core/styles";
import ContentGrid from "../../../../Helper/gridWrapper/gridWrapper";
import { ws } from "../../../../App";
import WebView from "../WebView";
import Alert from "../../../../Helper/alert/errorAlert";
import AlertComponent from "../../../../Helper/ErrorComponent/errorComponent";
import "./floatChat.css";
import "../message.css";
import { DialogTitle, IconButton } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import AppView from "../AppView";

const styles = {
  container: {
    padding: "20px",
  },
  root: {

  },
  paper: {
    position: "fixed",
    zIndex: 1000000,
    "@media (max-width: 649px)": {
      width: "100%",
    },
    "@media (min-width: 650px) and (max-width: 799px)": {
      width: "60%",
    },
    "@media (min-width: 800px) and (max-width: 1400px)": {
      width: "50%",
    },
    "@media (min-width: 1401px)": {
      width: "35%",
    },
  },
  modal: {

  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "lightgray",
    height: 50,
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: "100",
  },
};

class FloatChat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      connected: false,
      showInfo: false,
      userId: Number(this.props.user.AppUser.UserId),
      recentChatIndex: 1,
      showAlert: false,
      alertMessage: "",
      drawerOpened: true,
    };
  }

  toggleDrawer = (open) => () => {
    this.props.toggleDrawer(open, false);
  };

  componentDidMount() {
    let { messageData, getUnreadCount, showDrawer } = this.props;
    // if (messageData && messageData.connection) {
    //   if (!messageData.recentChat) {
    //     this.getRecentChat();
    //   } else {
    //     messageData.selectedChat &&
    //       this.props.unreadCountToZero(messageData.selectedChat.dialog_id);
    //   }
    // }

    if (messageData.connection) {
      ws.json({
        type: "ping",
      });
    }

    getUnreadCount();
  }

  componentWillUnmount() {
    this.props.emptyBackupChat();
  }

  updateState = (state, value) => {
    this.setState({
      [state]: value,
    });
  };

  getRecentChat = () => {
    if (
      this.state.messageData &&
      this.state.messageData.recentChat.length === 0
    ) {
      ws.json({
        user_id: this.state.userId,
        type: "recentchat",
        count: 20,
        index: 1,
      });
    }
    this.setState({
      recentChatIndex: 2,
    });
  };

  connection = () => {
    let { messageData } = this.props;
    if (messageData.connection) {
      if (!messageData.recentChat) {
        this.getRecentChat();
      }
      this.setState({
        connected: true,
      });
    }
  };

  onCLoseImage = () => {
    document.getElementById("myModal").style.display = "none";
  };

  onClick = () => {
    this.setState({ showInfo: false });
  };

  toggleAlert = (msg) => {
    this.setState({
      showAlert: !this.state.showAlert,
      alertMessage: msg,
    });
  };

  messagePanelStyles = () => {
    return {
      paddingBottom: "14px",
    };
  };

  render() {
    const { classes, user, error, showDrawer, showAllMessages } = this.props;
    const { showAlert, alertMessage } = this.state;

    !this.state.connected && this.connection();

    let showInfo = user.BusinessUser && user.BusinessUser.IsFirstVisit && JSON.parse(user.BusinessUser.IsFirstVisit)["My Feedback"];

    return (
      <Drawer
        open={showDrawer}
        onClose={this.toggleDrawer(false)}
        anchor={"right"}
        openSecondary={false}
        classes={{
          root: classes.root, // class name, e.g. `root-x`
          paper: classes.paper, // class name, e.g. `disabled-x`
          modal: classes.modal,
        }}
      >
          <div className={"floatChat"} id="floatChat">
          <DialogTitle
            disableTypography
            contentEditable={false}
            className={classes.header}
          >
            <IconButton onClick={this.toggleDrawer(false)}>
              <Close height={30} />
            </IconButton>
            <span
              style={{
                color: "#000",
                fontSize: 20,
                fontWeight: "500",
              }}
            >
              All Messages
            </span>
            <div></div>
          </DialogTitle>
          <div
            tabIndex={0}
            role="button"
            onClick={() => this.toggleDrawer(false)}
            onKeyDown={() => this.toggleDrawer(false)}
            style={{
              padding: "0px 10px 40px 0px",
            }}
          >
            {showAlert && (
              <AlertComponent
                msg={alertMessage}
                clickMethod={this.toggleAlert}
              />
            )}
            {error && <Alert />}
            <div>
              {showAllMessages && (
                <ContentGrid
                  content={
                    <Card
                      content={
                        <AppView
                          userId={this.state.userId}
                          recentChatIndex={this.state.recentChatIndex}
                          updateState={this.updateState}
                        />
                      }
                      CardContentProps={{ className: "appViewCardContent" }}
                      style={{
                        flexGrow: 0,
                        maxWidth: '96%',
                        flexBasis: '96%'
                      }}
                    />
                  }
                />
              )}
              <ContentGrid
                header={
                  showInfo ? (
                    <RouteHeader
                      title={"My Feedback"}
                      text={"Say Hello and respond to others."}
                      onClick={this.onClick}
                    />
                  ) : (
                    <span />
                  )
                }
                content={
                  <Card
                    id="webViewMessage"
                    CardContentProps={{
                      style: this.messagePanelStyles(),
                    }}
                    style={{
                      flexGrow: 0,
                      maxWidth: '96%',
                      flexBasis: '96%',
                      marginTop: '40px',
                    }}
                    content={
                      <WebView
                        userId={this.state.userId}
                        updateState={this.updateState}
                        toggleAlert={this.toggleAlert}
                        showInfo={showInfo}
                      />
                    }
                  />
                }
              />
              <div id="myModal" className="modal">
                <span
                  className="close custom-close"
                  onClick={this.onCLoseImage}
                >
                  &times;
                </span>
                <img className="modal-content" id="zoomImage" alt="img" />
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}

FloatChat.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    messageData: state.messageReducer,
    user: state.loginResponse.results,
    error: state.messageReducer.error,
    showDrawer: state.messageReducer.drawerStatus,
    showAllMessages: state.messageReducer.showAllMessages,
    toastList: state.messageReducer.toastList,
  };
};
const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getUnreadCount,
      unreadCountToZero,
      emptyBackupChat,
      toggleDrawer,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(withStyles(styles)(FloatChat));
